/**
 * Detects the locale based on URL parameter, user preference, or defaults to India
 * @returns {string} The detected locale country code
 */
export const detectLocale = (): string => {
    // Default to Indonesia in master-indonesia branch
    return "ID";
};
